import { render, staticRenderFns } from "./StackTypeSelector.vue?vue&type=template&id=4334bb04&"
import script from "./StackTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./StackTypeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports